import { createFileRoute } from '@tanstack/react-router';
import { ShipmentsListPage } from '../../features/shipments';

export const Route = createFileRoute('/portal/shipments/')({ component: ShipmentsListPage });
